
import { Options, Vue } from "vue-class-component";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, helpers } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PreviewAccountingReceipt from "../../components/PreviewAccountingReceipt.vue";
import { ref, defineComponent, toRefs, reactive, triggerRef } from "vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import ProfilerDialog from "../../components/ProfilerDialog.vue";
import { ItemList } from "../pos_receipt_refund/IPosReceiptRefund";
import router from "../../router";
import InputNumber from "primevue/inputnumber";
import Chips from "primevue/chips";
import BranchValidator from "../../utils/branchValidator.js";
import FooterService from "../../service/footerService.js";

interface PaymentListType {
  paymentType: string;
  accountNo: string;
  terminalId: string;
  authCode: string;
  transId: string;
  transStatus: string;
  transType: string;
  transDate: string;
  transTime: string;
  transAmount: number;
  transTotalAmount: number;
  transRef: string;
  entryMode: string;
  hostResponse: string;
  giftCardRef: string;
  cardBalance: string;
  tendered: number;
  change: number;
  roundOff: number;
}

interface CounterEntry {
  accountID: number;
  accountHead: string;
  amount: number;
  type: string;
}

interface RefundItem extends ItemList {
    _stockRows?: RefundItem[];
}

@Options({
  title: 'Order Refund',
  components: {
    AutoComplete,
    SearchFilter,
    PreviewAccountingReceipt,
    PaymentScreen,
    ProfilerDialog,
    Chips,
  },

  //adding this option to make the unit price calculation at the item select event
  watch: {
      savedItemList: {
        handler(newList) {
          // Find the newly added item
        const newItem = newList.find(item => !this.previousItemList.some(prevItem => prevItem.id === item.id));
        if (newItem) {
          this.setPricing(newItem);
        }

        // Update previousItemList
        this.previousItemList = [...newList];
      },
        deep: true, // Ensures that changes in nested properties are also detected
      },
      'state.chippedTel': {
        handler(newVal) {
          if (newVal.length === 0) {
            this.triggerDelayedTel(true);
          } else {
            this.delayedChippedTel = false;
          }
        },
        immediate: true,
        deep: true,
      },

    }
})

export default class PosReceiptRefund extends Vue {
  private modeList = [
    { label: "REFUND", value: "RFD" },
    { label: "SALE", value: "INE" },
    // { label: "TRANSFER", value: "TRN" },
  ];
  private unitType = ["Pack", "Strip", "Unit"];
  private discountType = [{key:2, name:"Flat"},{key:1, name:"Percentage"}];
  private invoiceDiscount = "";
  private discType = "Flat";
  private paymentDialog = false;
  private profileStatus = false;
  private statusType = "New";
  private storeName = "Loading...";
  private refundReceiptDialog = true;
  private removeProfileDialog = false;
  private submitted = false;
  private defaultCustomerName = "";
  private defaultCustomerID = 0;
  private currentUserID = 0;
  private screenMode = "minimize";
  private profilerService;
  private posService;
  private toast;
  private storeList = [];
  private profilerList = [];
  private itemList = [];
  private store = useStore();
  private isToggled = "";
  private delayedChippedTel: boolean= false;
  private cashPaymentOption = true;
  private cardPaymentOption = true;
  private bankTransferPaymentOption = true;
  private payLaterOption = true;
  private validationPopupMessage = 'Please fill all the required fields to proceed';
  private validationPopup = false;
  private paidAmount = 0;
  private initialTotalAmount = 0;

  private counterEntry: CounterEntry [] = [];

  private screenState = reactive({
    fullscreen: false,
    teleport: true,
    pageOnly: false,
  });

  private selectedTaxes = {
    tax1: false,
    tax2: false,
    tax3: false,
  };

  private taxNames = [
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
  ];

  private state = reactive({
    selectedProfile: "",
    chippedProfile: [] as string[],
    customerTel: "",
    chippedTel: [] as string[],
    transferStoreID: "",
  });

  private savedItemList: RefundItem[] = [];
  private savedItemListAll: any[] = [];
  private previousItemList: RefundItem[] = [];

  private validationRules = {
    selectedProfile: {
      required,
    },
    transferStoreID: {
      required: helpers.withMessage(
        "Transfer Store is required",
        requiredIf(() => {
          return this.item.type == "TRN";
        })
      ),
    },
  };

  private paymentList: PaymentListType [] = [];

  private item = {
    id: 0,
    receiptID: 0,
    profileID: this.defaultCustomerID,
    discount: 0,
    totalPaid: 0,
    totalTendered: 0,
    totalChange: 0,
    totalGrossAmt: 0,
    totalCost: 0,
    totalBill: 0,
    totalTax1: 0,
    totalTax2: 0,
    totalTax3: 0,
    totalTax: 0,
    description: "",
    paymentMethod: "",
    doctorDetails: "",
    remark:"",
    patientDetails: "",
    searchReceiptNo: "",
    status: "Active",
    type: "RFD",
  };

  private v$ = useVuelidate(this.validationRules, this.state);

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.profilerService = new ProfilerService();
    this.posService = new PosService();
    this.toast = new Toaster();
  }

  mounted() {
    this.loadList();
    
    // Fetch and store current branch on page load to ensure validation works from first search
    const footerService = new FooterService();
    footerService.branchDetail().then((res) => {
        if (res.store_info) {
            BranchValidator.storeTransactionBranch(
                res.store_info.id,
                res.store_info.name,
                'POS_REFUND',
                res.store_info.pharmacy?.name || ''
            );
        }
    });
    
    // Add event listeners for keyboard navigation
    window.addEventListener('keypress', this.handleKeypress);
    window.addEventListener('keydown', this.handleKeydown);
  }
  
  beforeUnmount() {
    // Remove event listeners
    window.removeEventListener('keypress', this.handleKeypress);
    window.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    // Handle special keys that need keydown event
    if (!this.paymentDialog && !this.refundReceiptDialog && !this.validationPopup) {
      // Escape key - Focus HOME button
      if (event.key === 'Escape') {
        event.preventDefault();
        this.focusNext('homeBtn', null, null);
        return;
      }
      // F11 key - Toggle fullscreen
      if (event.key === 'F11') {
        event.preventDefault();
        this.toggleScreen();
        return;
      }

      if (event.key === "Insert") {
        // Key "-" - Open search refund dialog
        event.preventDefault();
        this.refundReceiptDialog = true;
        setTimeout(() => {
          this.focusNext('search_receipt', null, null);
        }, 100);
        return '';
      }
    } else if (this.validationPopup) {
      // Escape key - Close validation popup
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeValidationPopup();
        return;
      }
    } else if (this.refundReceiptDialog) {
      // Enter key - Search receipt
      if (event.key === 'Enter') {
        event.preventDefault();
        if (this.item.searchReceiptNo !== '') {
          this.fetchReceiptNo();
        }
        return;
      }
    }
  }

  handleKeypress(event) {
    if (!this.paymentDialog && !this.refundReceiptDialog && !this.validationPopup) {
      console.log('Key pressed:', event.key, 'KeyCode:', event.keyCode);
      if (event.keyCode === 42) {
        // Key "*" - Proceed to payment/next
        event.preventDefault();
        const el = document.getElementById('nextBtn');
        if (el instanceof HTMLButtonElement && !el.disabled) {
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
          el.click();
        } else {
          this.validationPopupMessage = 'Please fill the required fields and proceed';
          this.validationPopup = true;
          setTimeout(() => {
            this.focusNext('closePopup', null, null);
          }, 100);
        }
        return '';
      }
      if (event.keyCode === 43) {
        // Key "+" - Focus remark field
        this.focusNext('item-unit-' + this.getTopMostItem(), null, null);
        return '';
      }
      if (event.keyCode === 94 || event.keyCode === 45) {
        // Key "-" - Open search refund dialog
        event.preventDefault();
        this.refundReceiptDialog = true;
        setTimeout(() => {
          this.focusNext('search_receipt', null, null);
        }, 100);
        return '';
      }
    }
  }

  focusNext(refName, event, special) {
    var tempElement = document.getElementById(refName);
    if (special) {
      // for special cases
      if (special === 'back_to_remark') {
        // this if for Item menu
        if (!tempElement) {
          tempElement = document.getElementById('remarkField');
        }
      } else if (special === 'search_bar') {
        const wrapper = document.getElementById('remarkField');
        if (wrapper) {
          const span = wrapper.closest('span');
          if (span && span.getAttribute('aria-expanded') === 'true') {
            return;
          }
        }
      }

      if (special !== 'search_bar') {
        if (event) {
          event.preventDefault();
        }
      }
    }

    console.log(tempElement);
    if (tempElement) {
      tempElement.focus();
    }
  }
    getTopMostItem() {
        const activeItems = this.savedItemListAll.filter(item => item.active === 1);
        if (activeItems.length === 0) return 0;
        
        // Get the maximum rowID (top-most item)
        const rowIDs = activeItems.map(item => item.rowID);
        return Math.max(...rowIDs);
    }

    getBottomMostItem() {
        const activeItems = this.savedItemListAll.filter(item => item.active === 1);
        if (activeItems.length === 0) return 0;
        
        // Get the minimum rowID (bottom-most item)
        const rowIDs = activeItems.map(item => item.rowID);
        return Math.min(...rowIDs);
    }

    getNextActiveItem(currentRowID) {

        console.log(this.savedItemListAll);
        console.log(this.savedItemListAll.sort((a, b) => a.rowID - b.rowID));
        if (this.savedItemListAll.length === 0) return 0;

        let flagVar = 0;
        for (const element of this.savedItemListAll.sort((a, b) => a.rowID - b.rowID)) {
            if(element.active === 1){
                if(element.rowID == currentRowID){
                    console.log('selected element:');
                    console.log(element);
                    flagVar = 1;
                } else if(flagVar == 1){
                    console.log('next element:');
                    console.log(element);
                    return element.rowID;
                }
            }
        }
    }

    getPreviousActiveItem(currentRowID) {
        console.log(this.savedItemListAll);
        console.log(this.savedItemListAll.sort((a, b) => b.rowID - a.rowID));
        if (this.savedItemListAll.length === 0) return 0;

        let flagVar = 0;
        for (const element of this.savedItemListAll) {
            if(element.active === 1){
                if(element.rowID == currentRowID){
                    console.log('selected element:');
                    console.log(element);
                    flagVar = 1;
                } else if(flagVar == 1){
                    console.log('next element:');
                    console.log(element);
                    return element.rowID;
                }
            }
        }
    }

  toggleScreen() {
    this.screenState.fullscreen = !this.screenState.fullscreen;
  }

  get progressBar() {
    return this.store.getters.getProgressBar;
  }

  searchProfiler(event) {
    setTimeout(() => {
      let param = event.query.trim();
      if (param && param.startsWith('0')) {
        param = param.replace(/^0+/, '');
      }
      this.profilerService.searchProfiler(param).then((data) => {
        this.profilerList = data.records;
        data.records.forEach((record) => {
            if (record.contact_no === param && data.records.length === 1){
              const event = { value: data.records[0] };
              this.saveProfile(event);
            }
        }); 
               
      });
    }, 200);
  }


  saveProfile(event) {
  const profileInfo = event.value;
  this.state.selectedProfile = profileInfo.account_title;

  this.state.customerTel = profileInfo.contact_no.replace(/^0+/, '');

  // Add the contact number to chippedTel if it is not already present
  if (!this.state.chippedTel.includes(this.state.customerTel)) {
    this.state.chippedTel.push(this.state.customerTel);
  }

  // Add the account title to chippedProfile if it is not already present
  if (!this.state.chippedProfile.includes(profileInfo.account_title)) {
    this.state.chippedProfile.push(profileInfo.account_title);
  }

  // Set the profile ID
  this.item.profileID = profileInfo.id;
}

triggerDelayedTel(value) {
    setTimeout(() => {
      this.delayedChippedTel = value;
    }, 20); // Adjust the delay as needed (200ms here)
  }

  loadList() {
    this.posService.getItems().then((data) => {
      // //taxNames
      this.taxNames = [];

      this.storeList = data.stores;

      if (data.storeTaxes && data.storeTaxes[0]) {
        this.taxNames.push({
          taxName: data.storeTaxes[0].tax_name_1,
          show: data.storeTaxes[0].show_1 == "true" ? true : false,
          optionalReq: data.storeTaxes[0].required_optional_1,
          taxValue:
            data.storeTaxes[0].show_1 == "true"
              ? Number(data.storeTaxes[0].tax_value_1)
              : 0,
          accountHead: data.storeTaxes[0].tax_name1?.chartName || '',
          accountID: data.storeTaxes[0].link1,
        });

        this.taxNames.push({
          taxName: data.storeTaxes[0].tax_name_2,
          show: data.storeTaxes[0].show_2 == "true" ? true : false,
          optionalReq: data.storeTaxes[0].required_optional_2,
          taxValue:
            data.storeTaxes[0].show_2 == "true"
              ? Number(data.storeTaxes[0].tax_value_2)
              : 0,
          accountHead: data.storeTaxes[0].tax_name2?.chartName || '',
          accountID: data.storeTaxes[0].link2,
        });

        this.taxNames.push({
          taxName: data.storeTaxes[0].tax_name_3,
          show: data.storeTaxes[0].show_3 == "true" ? true : false,
          optionalReq: data.storeTaxes[0].required_optional_3,
          taxValue:
            data.storeTaxes[0].show_3 == "true"
              ? Number(data.storeTaxes[0].tax_value_3)
              : 0,
          accountHead: data.storeTaxes[0].tax_name3?.chartName || '',
          accountID: data.storeTaxes[0].link3,
        });

        if (
          this.taxNames[0].optionalReq == "Required" &&
          this.taxNames[0].show == true
        ) {
          this.selectedTaxes.tax1 = true;
        }

        if (
          this.taxNames[1].optionalReq == "Required" &&
          this.taxNames[1].show == true
        ) {
          this.selectedTaxes.tax2 = true;
        }

        if (
          this.taxNames[2].optionalReq == "Required" &&
          this.taxNames[2].show == true
        ) {
          this.selectedTaxes.tax3 = true;
        }
      }

      //Default Customer
      this.state.selectedProfile = data.defaultCustomer.account_title;
      this.item.profileID = data.defaultCustomer.id;
      this.defaultCustomerName = data.defaultCustomer.account_title;
      this.defaultCustomerID = data.defaultCustomer.id;
      this.currentUserID    = data.currentUserID;
      this.storeName       = data.storeName;
    });
  }

  getTheSubtotal(data) {
    let totalUnits = this.sumUnitTotalQty(data);

    if (data.stockQty < totalUnits && this.item.type != "RFD") {
      data.unit = 0;
      data.mode = "Unit";
      data.freeUnit = 0;
      this.toast.showError("Item does not have enough stock quantity");
    }

    const qty = Number(data.unit);
    const price = Number(data.sellingPrice);
    const discount = Number(data.itemDisc);

    const tax1 = this.selectedTaxes.tax1 == true ? Number(data.tax1) : 0;
    const tax2 = this.selectedTaxes.tax2 == true ? Number(data.tax2) : 0;
    const tax3 = this.selectedTaxes.tax3 == true ? Number(data.tax3) : 0;

    const total = qty * price;
    const disAmount = Number(((total / 100) * discount).toFixed(2)); 

    const afterDis = total - disAmount;
    const afterTax = Number(((afterDis / 100) * (tax1 + tax2 + tax3)).toFixed(2));

    const netTotal = afterDis + afterTax;

    data.subTotal = Number(this.fixDigits(netTotal));

    //TOTAL UNITS
    if (data.mode == "Pack") {
      data.totalUnit = (data.packSize * data.unit) + data.freeUnit;
    } else if (data.mode == "Strip") {
      data.totalUnit = (data.sheetSize * data.unit) + data.freeUnit;
    } else {
      data.totalUnit = data.unit + data.freeUnit;
    }

    return this.fixDigits(netTotal);
  }

  //This part prevent unneccessary characters being entered in the qty input field
  validateUnit(savedItem, event) {
        // Get the input value
        let inputValue = event.target.value;
        //console.log(event.target.value);
        // Allow only digits (no decimal points for quantity)
        let numericValue = inputValue.replace(/[^0-9]/g, "");

        // Parse the value and ensure it's a valid number
        const finalValue = isNaN(Number(numericValue))
            ? numericValue
            : Number(numericValue);

        // Update savedItem.unit with valid integer value
        savedItem.unit = finalValue;

        // Update the input field value directly, allowing user to see the current input
        event.target.value = numericValue;
  }

  get totalGross() {
      let total = 0;
      this.savedItemList.forEach((e) => {
          total = total + Number((e.sellingPrice * e.unit).toFixed(2));
      });
      return Number(total.toFixed(2));
  }
  
  get totalCostInventory() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      total = total + e.purchasePrice * e.unit;
    });

    return total;
  }

  get totalTax1() {
    let total = 0;

    this.savedItemList.forEach((e) => {
      const tax = this.selectedTaxes.tax1 == true ? Number(e.tax1) : 0;
      const price = e.sellingPrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      const lineTax = Number((((price - afterDisc) / 100) * tax).toFixed(2));
      total = total + lineTax;
    });

    return Number(total.toFixed(2));
  } 

  get totalTax2() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      const tax = this.selectedTaxes.tax2 == true ? Number(e.tax2) : 0;
      const price = e.sellingPrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      const lineTax = Number((((price - afterDisc) / 100) * tax).toFixed(2));
      total = total + lineTax;
    });

    return Number(total.toFixed(2));
  }

  get totalTax3() {
    let total = 0;
    this.savedItemList.forEach((e) => {
      const tax = this.selectedTaxes.tax3 == true ? Number(e.tax3) : 0;
      const price = e.sellingPrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      const lineTax = Number((((price - afterDisc) / 100) * tax).toFixed(2));
      total = total + lineTax;
    });

    return Number(total.toFixed(2));
  }

  get totalDiscAmount() {
      const total = this.itemDiscAmount + this.extraDiscAmount;
      return Number(total.toFixed(2));
  }

  get itemDiscAmount() {
      let itemtotal = 0;
      this.savedItemList.forEach((e) => {
          const price = e.sellingPrice * e.unit;
          const lineDisc = Number(((price / 100) * e.itemDisc).toFixed(2));
          itemtotal = itemtotal + lineDisc;
      });
      return Number(itemtotal.toFixed(2));
  }

  get extraDiscAmount() {
      let extraDiscVal = 0;
      const itemtotal = this.itemDiscAmount;
      const invoiceDiscount = Number(this.invoiceDiscount) || 0;
      if (this.discType == "Flat") {
          extraDiscVal = invoiceDiscount;
      } else {
          extraDiscVal = ((this.totalGross - itemtotal) / 100) * invoiceDiscount;
      }
      return Number(extraDiscVal.toFixed(2));
  }

  get netTotal() {
    return Number(
      (
        this.totalGross -
        this.totalDiscAmount +
        this.totalTax1 +
        this.totalTax2 +
        this.totalTax3
      ).toFixed(2)
    );
  }

  get netTotalBeforDisc() {
    return Number(
      (
        this.totalGross +
        this.totalTax1 +
        this.totalTax2 +
        this.totalTax3
      ).toFixed(2)
    );
  }

  setPricing(data) {
    if (data.mode == "Pack") {
      data.sellingPrice = data.originalSPrice;
      data.purchasePrice = data.originalPPrice;
    } else if (data.mode == "Strip") {
      if (data.sheetSize != 0) {
        data.sellingPrice = (data.originalSPrice / data.packSize) * data.sheetSize;
        data.purchasePrice = data.originalPPrice / data.sheetSize;
      }
    } else {
      if (data.packSize != 0) {
        data.sellingPrice = data.originalSPrice / data.packSize;
        data.purchasePrice = data.originalPPrice / data.packSize;
      }
    }
  }

  fixDigits(amt, digits = 2) {
    let total = 0;
    if (amt != null) {
      total = amt.toFixed(digits);
    }
    return total;
  }

  clearAll() {
    this.state.selectedProfile = this.defaultCustomerName;
    this.state.customerTel = "";
    this.state.transferStoreID = "";
    this.state.chippedProfile = [];
    this.state.chippedTel = [];

    this.savedItemList = [];
    this.savedItemListAll = [];
    this.paymentList =  [];

    this.item = {
      id: 0,
      receiptID: 0,
      profileID: this.defaultCustomerID,
      discount: 0,
      totalGrossAmt: 0,
      totalCost: 0,
      totalBill: 0,
      totalPaid: 0,
      totalTendered: 0,
      totalChange: 0,
      totalTax1: 0,
      totalTax2: 0,
      totalTax3: 0,
      totalTax: 0,
      description: "",
      searchReceiptNo: this.item.searchReceiptNo,
      paymentMethod: "",
      doctorDetails: "",
      remark:"",
      patientDetails: "",
      status: "Active",
      type: this.item.type,
    };

    this.invoiceDiscount = "";
  }

  formatExpiryDate(d) {
    return moment(d).format("DD-MMM-YYYY");
  }

  adjustQty(type, item) {
    
    if (type == "minus" && item.unit > 1) {
      if(item.unit > item.refundUnit){
        item.unit =  item.refundUnit;
      } else {
        item.unit--;
      }
    } else if (type == "add") {
      if (item.unit < item.refundUnit) {
        item.unit++;
      } else {
        this.toast.showError("Can't refund more than the ordered quantity");
      }
    }
  }

  // adjustFreeQty(type, item) { COMMENTED BY JEEWAKA SUSPECTING UNWANTED FUNCTION
  //   if (type == "minus" && item.freeUnit > 0) {
  //     item.freeUnit--;
  //   } else if (type == "add") {
  //     if (item.unit + item.freeUnit < item.stockQty) {
  //       item.freeUnit++;
  //     } else {
  //       this.toast.showError(
  //         "Item does not have enough stock quantity to provide free units"
  //       );
  //     }
  //   }
  // }

  clearListItem(item) {
    console.log(item);
    const answer = window.confirm("Do you want to remove this item?");
    if (answer) {
        this.savedItemList.splice(this.savedItemList.indexOf(item), 1);
        this.savedItemListAll[this.savedItemListAll.findIndex(i => i.rowID === item.rowID)].active = 0;
        this.toast.showSuccess("Item Deleted Successfully");
        this.focusNext("item-unit-" + this.getTopMostItem(), null, null);
    } else {
        // do nothing
    }
  }

  limitString(str) {
    if (str.length > 40) str = str.substring(0, 40) + "...";
    return str;
  }

  closeValidationPopup(){
    this.validationPopup = false;
  }

  closePaymentScreen() {
    this.paymentDialog = false;
  }

  getProceededPayments(paymentList, isToggled) {
    this.paymentList = paymentList;
    const tenderedList = this.getTotalPaid(paymentList);
    this.item.totalPaid = Number(tenderedList[0]);
    this.item.totalTendered = Number(tenderedList[1]);
    this.item.totalChange = Number(tenderedList[2]);

    const payedMethod = this.getPaymentMethod(paymentList);
    this.item.paymentMethod = payedMethod.payMethod;


    this.item.discount = this.totalDiscAmount;
    this.item.totalGrossAmt = this.totalGross;
    this.item.totalCost = this.totalCostInventory;
    this.item.totalBill = this.netTotal;
    this.item.totalTax1 = this.totalTax1;
    this.item.totalTax2 = this.totalTax2;
    this.item.totalTax3 = this.totalTax3;
    this.item.totalTax = Number(
      this.totalTax1 + this.totalTax2 + this.totalTax3
    );

    this.setAccountingEntries();

    const expandedItemList: any[] = [];
    this.savedItemList.forEach(item => {
        if (item._stockRows && item._stockRows.length > 1) {
            const totalRefundUnits = item.unit; // what user wants to refund
            const totalOriginalUnits = item._stockRows!.reduce((sum: number, r: any) => sum + r.unit, 0);
            let remaining = totalRefundUnits;

            item._stockRows!.forEach((stockRow: any, idx: number) => {
              const isLast = idx === item._stockRows!.length - 1;
              // FIFO: take as much as possible from this row first
              const proportion = isLast
                  ? remaining
                  : Math.min(remaining, stockRow.unit);  // use stockRow.unit (per-stock qty)
              if (proportion > 0) {
                  expandedItemList.push({
                      ...stockRow,
                      unit: proportion,
                      totalUnit: proportion,
                      subTotal: Number((proportion * stockRow.sellingPrice * (1 - stockRow.itemDisc / 100)).toFixed(2)),
                  });
                  remaining -= proportion;
              }
          });
        } else {
            expandedItemList.push(item);
        }
    });

    this.posService
      .refundItem(this.item, this.paymentList, this.state, expandedItemList, this.counterEntry, isToggled)
      .then((res) => {
        if (res.original?.alert === 'frozen' || res.alert === 'frozen') {
            this.validationPopupMessage = res.original?.msg ?? res.msg;
            this.validationPopup = true;
            return;
        }
        
        if (res.original.alert == "info") {
          this.clearAll();
          this.item.searchReceiptNo = "";
          this.toast.showSuccess(res.original.msg);
          this.generatePosReceipt(res);
        }
      });

    this.paymentDialog = false;
    this.submitted = false;
  }

  generatePosReceipt(res){
    if (res.original.htmlTemplate) {
                 // Open a new window and write the HTML content to it
                 const printWindow = window.open('', '_blank');
                if (printWindow !== null) {
                    printWindow.document.open();
                    printWindow.document.write(`
                        <html>
                            <head>
                                <title>Print Receipt</title>
                            </head>
                            <body onload="setTimeout(function() { window.print(); window.close(); }, 300)">
                                ${res.original.htmlTemplate} <!-- HTML content from the response -->
                            </body>
                        </html>
                    `);
                    printWindow.document.close(); // Close the document
                    // printWindow.focus(); // Focus on the new window
                    // printWindow.print(); // Trigger the print dialog
                    // printWindow.close(); // Close the window after printing
                }
            }
  }
  
  validateItems(){
    let validated = 1;
    let errorMessage = '';
  
    // check for duplicates
    const seen = new Set();
    this.savedItemList.filter((item) => {
      //console.log(item);
      if(!(item.unit > 0)){
        errorMessage = 'Please fill all the required fields to proceed'; // if item is already in the Set, it's a duplicate
        validated = 0;
      }
      if(item.unit > item.refundUnit){
        errorMessage = 'Cannot refund excess quantities than Ordered'; // if item is already in the Set, it's a duplicate
        validated = 0;
      }
      if(this.item.remark == ""){
        errorMessage = 'Please update the Remark to continue'; // if item is already in the Set, it's a duplicate
        validated = 0;
      }
    });

    return {status: validated, message: errorMessage};
  }

  openPaymentMethod(isFormValid) {
    let validateDetails = this.validateItems();
    if(validateDetails.status == 0){
      this.validationPopupMessage = validateDetails.message;
      this.validationPopup = true;
      return false;
    }

    this.submitted = true;
    // getting correct total
    
    if (isFormValid = true) {
      if(this.state.customerTel === ""){
        this.isToggled = "Pos Receipt"
      }else {
        this.isToggled ="E Receipt"
      }
      this.paymentDialog = true;
      this.store.dispatch(
        ActionTypes.TOTAL_BILL,
        Number(this.fixDigits(this.netTotal))
        // (this.paidAmount - (this.initialTotalAmount - this.netTotal) < 0)?Number(0):Number(this.paidAmount - (this.initialTotalAmount - this.netTotal)),
      );
    }
  }

  get totalPaidCash()
  {
    let total = 0;

    this.paymentList.forEach(e => {
      if(e.paymentType == 'Cash')
      {
        total = total + e.transTotalAmount;
      }
    });

    return total;
  }

  get totalPaidBank()
  {
    let total = 0;

    this.paymentList.forEach(e => {
      if(e.paymentType != 'Cash')
      {
        total = total + e.transTotalAmount;
      }
    });

    return total;
  }

  getTotalPaid(paymentList) {
    let totalPaid = 0;
    let totalTendered = 0;
    let totalChange = 0;

    paymentList.forEach((e) => {
      if (e.paymentType != "Tip") {
        totalPaid = totalPaid + Number(e.transTotalAmount);
        totalTendered = totalTendered + Number(e.tendered);
        totalChange = totalChange + Number(e.change);
      }
    });

    return [totalPaid, totalTendered, totalChange];
  }

  get totalBalance()
  {
    return this.netTotal - this.item.totalPaid;
  }

  getPaymentMethod(paymentList) {
    let payMethod = "";
    let payMethodId = 0;

    if (paymentList.length == 0) {
      payMethod = "Pay Later";
      payMethodId = 2;
    } else if (paymentList.length == 1) {
      payMethod = paymentList[0].paymentType;
      payMethodId = paymentList[0].paymentTypeID;
    } else if (paymentList.length > 1) {
      payMethod = "Split";
      payMethodId = 0;
    }

    return {payMethod:payMethod, paymentMethodId:payMethodId};
  }

  shiftINE(){
    this.refundReceiptDialog = false;
    this.focusNext('remarkField', null, null);
  }


  sumUnitTotalQty(data) {
    let totalUnits = 0;

    this.savedItemList.forEach((e) => {
      if (data.stockID == e.stockID) {
        if (e.mode == "Pack") {
          totalUnits = totalUnits + (e.packSize  * e.unit)  + e.freeUnit;
        } else if (e.mode == "Strip") {
          totalUnits = totalUnits + (e.sheetSize * e.unit)  + e.freeUnit;
        } else {
          totalUnits = totalUnits + (e.freeUnit + e.unit);
        }
      }
    });

    return Number(totalUnits);
  }

  fetchReceiptNo() {
    this.posService.getReceiptItems(this.item.searchReceiptNo).then((data) => {
      this.clearAll();
      if(data.receipt == null){
        if(data.alert == 'info'){
          this.toast.showInfo(data.msg);
        } else {
          this.toast.showError(data.msg);
        }
      }

      if (data.receipt != null) {
        this.state.selectedProfile = data.receipt.profile_name.accountName;
        if(data.receipt.disc_type_id == '2'){
          this.discType = 'Flat';
        } else { 
          this.discType = 'Percentage';
        }
        this.invoiceDiscount = data.receipt.invoice_discount;
        this.item.profileID = data.receipt.profile_name.id;
        this.item.patientDetails =
          data.receipt.patient_details == null
            ? ""
            : data.receipt.patient_details;
        this.item.description =
          data.receipt.description == null ? "" : data.receipt.description;
        this.item.doctorDetails =
          data.receipt.doctor_details == null
            ? ""
            : data.receipt.doctor_details;

        if (data.receipt.total_tax1 > 0) {
          this.selectedTaxes.tax1 = true;
        }

        if (data.receipt.total_tax2 > 0) {
          this.selectedTaxes.tax2 = true;
        }

        if (data.receipt.total_tax3 > 0) {
          this.selectedTaxes.tax3 = true;
        }
      }
      
      if (data.receiptItems != null) {

        var sumOfPayments = 0;
        for(let i=0;i<data.receipt.receipt_balance.length;i++){
          // console.log();
          sumOfPayments += Number(data.receipt.receipt_balance[i].trans_amount) || 0;
        }
        this.paidAmount = sumOfPayments;
        this.item.receiptID = data.receipt.id;
        // this.paidAmount = data.receipt.total_tendered - data.receipt.total_change;
        this.initialTotalAmount = data.receipt.total_bill;
        data.receiptItems.forEach((e) => {
          var rowID = this.savedItemListAll.length + 1;
          this.savedItemList.push({
            mode: e.mode,
            rowID: rowID,
            stockID: Number(e.stock_id),
            productID:Number(e.product_id),
            productName: e.product_detail.product_name,
            generic:e.product_detail.generic_name,
            batchNo:e.stock_detail.batch_no,
            itemDescription: e.stock_detail.batch_no,
            unit: Number(e.unit),
            totalUnit: Number(e.total_unit),
            refundUnit: Number(e.total_unit),
            stockQty: Number(e.stock_detail.qty),
            freeUnit: Number(e.free_unit),
            supplierBonus: Number(e.supplier_bonus),
            packSize: Number(e.pack_size),
            sheetSize: Number(e.sheet_size),
            purchasePrice: Number(e.stock_detail.purchase_price),   
            originalPPrice: Number(e.stock_detail.purchase_price),
            originalSPrice: Number(e.stock_detail.sale_price),
            sellingPrice: Number(e.selling_price),
            mrp: Number(e.mrp),
            brandName: e.brand_name,
            sectorName: e.sector_name,
            categoryName: e.category_name,
            productType: e.product_type,
            expiryDate: e.expiry_date,
            itemDisc: Number(e.item_disc),
            tax1: Number(e.tax_1),
            tax2: Number(e.tax_2),
            tax3: Number(e.tax_3),
            subTotal: Number(e.sub_total),
          });
                    // Add to savedItemListAll for navigation tracking
          const dataForAll = {
            active: 1,
            rowID: rowID
          };
          this.savedItemListAll.push(dataForAll);
        });

        const displayMap = new Map<string, any>();
        this.savedItemList.forEach(item => {
            const key = `${item.productID}_${item.batchNo}_${item.sellingPrice}`;
            if (displayMap.has(key)) {
                const existing = displayMap.get(key);
                existing.unit      += item.unit;
                existing.totalUnit += item.totalUnit;
                existing.refundUnit += item.refundUnit;
                existing.subTotal = (existing.unit * existing.sellingPrice) * (1 - existing.itemDisc / 100);
                existing._stockRows.push(item);
            } else {
                const clone = { ...item, _stockRows: [item] };
                displayMap.set(key, clone);
            }
        });

        // ── Sort _stockRows ascending by stockID so FIFO takes oldest purchase first ──
        displayMap.forEach(item => {
            if (item._stockRows && item._stockRows.length > 1) {
                item._stockRows.sort((a: any, b: any) => b.stockID - a.stockID);
            }
        });

        this.savedItemList = Array.from(displayMap.values());

        this.refundReceiptDialog = false;
        this.focusNext('remarkField', null, null);
      }
    });
  }

  removeProfile(event){
    this.state.selectedProfile= "";
    this.state.customerTel = "";
    this.state.chippedProfile = [];
    this.state.chippedTel = [];
    this.item.profileID = 1;
 
     // Remove only the specific profile and contact number
    const chipIndex = this.state.chippedTel.indexOf(event.value);
    
    if (chipIndex !== -1) {
      this.state.chippedTel.splice(chipIndex, 1);
      this.state.chippedProfile.splice(chipIndex, 1);
 
      // Clear additional state only if no chips remain
      if (this.state.chippedTel.length === 0) {
        this.state.selectedProfile = "";
        this.state.customerTel = "";
      }
    }
  }

  updateProfilerStatus(res) {
    this.profileStatus = false;
    if (res[0] == "load") {
      this.state.selectedProfile = res[1].account_title;
      this.state.customerTel = res[1].contact_no;
      this.item.profileID = res[1].id;
    }
  }

  redirectHome()
  {
    this.screenState.fullscreen = false;
    router.replace({ path: "/home/dashboard", });
  }

  // isExpiryDateCritical(date: { expiry_date: string }): string { COMMENTED BY JEEWAKA SUSPECTING UNWANTED FUNCTION
  //   const today = new Date();
  //   const expiryDate = new Date(date.expiry_date);
  //   const diffTime = expiryDate.getTime() - today.getTime(); // Use getTime() to get milliseconds
  //   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    
  //   if(diffDays < 0){
  //     return 'expired-date'
  //   }else if(diffDays <= 31 && diffDays > 0){
  //     return 'expired-date-month'
  //   }else if(diffDays <= 92 && diffDays >=31){
  //     return 'expired-date-3months'
  //   }else if(diffDays <= 183 && diffDays >=92){
  //     return 'expired-date-6months'
  //   }else{
  //     return ''
  //   } 
  // }

  setAccountingEntries() {
   
    this.counterEntry = [];

    if (this.item.type == "INE") {
      if (this.totalBalance == 0) {

        if (this.totalPaidCash > 0) {
          this.counterEntry.push({
            accountID: 2,
            accountHead: 'Cash in hand',
            amount: this.totalPaidCash,
            type: "Debit",
          });
        }
        
        if (this.totalPaidBank > 0) {
          this.counterEntry.push({
            accountID: 8,
            accountHead: 'Cash at bank',
            amount: this.totalPaidBank,
            type: "Debit",
          });
        }

      } else if (this.totalBalance == this.netTotal) {
        this.counterEntry.push({
          accountID: 4,
          accountHead: "Accounts receivable",
          amount: this.netTotal,
          type: "Debit",
        });
      } else if(this.totalBalance > 0 && this.item.totalPaid > 0) {
          if (this.totalPaidCash > 0) {
            this.counterEntry.push({
              accountID: 2,
              accountHead: 'Cash in hand',
              amount: this.totalPaidCash,
              type: "Debit",
            });
          }
          
          if (this.totalPaidBank > 0) {
            this.counterEntry.push({
              accountID: 8,
              accountHead: 'Cash at bank',
              amount: this.totalPaidBank,
              type: "Debit",
            });
          }

          this.counterEntry.push({
            accountID: 4,
            accountHead: "Accounts receivable",
            amount: this.totalBalance,
            type: "Debit",
          });
      }

        this.counterEntry.push({
          accountID: 56,
          accountHead: 'Cost of Goods',
          amount: this.totalCostInventory,
          type: "Debit",
        });
        
        
        this.counterEntry.push({
          accountID: 48,
          accountHead: 'Sales Revenue',
          amount: this.totalGross-this.totalDiscAmount,
          type: "Credit",
        });

        this.counterEntry.push({
          accountID: 3,
          accountHead: 'Inventory',
          amount: this.totalCostInventory,
          type: "Credit",
        });

      //ADDING TAXES
      if (this.totalTax1 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[0].accountID,
          accountHead: this.taxNames[0].accountHead,
          amount: this.totalTax1,
          type: "Credit",
        });
      }

      if (this.totalTax2 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[1].accountID,
          accountHead: this.taxNames[1].accountHead,
          amount: this.totalTax2,
          type: "Credit",
        });
      }

      if (this.totalTax3 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[2].accountID,
          accountHead: this.taxNames[2].accountHead,
          amount: this.totalTax3,
          type: "Credit",
        });
      }
    } else if(this.item.type == "RFD") {

        this.counterEntry.push({
          accountID: 48,
          accountHead: 'Sales Revenue',
          amount: this.totalGross-this.totalDiscAmount,
          type: "Debit",
        });



      //ADDING TAXES
      if (this.totalTax1 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[0].accountID,
          accountHead: this.taxNames[0].accountHead,
          amount: this.totalTax1,
          type: "Debit",
        });
      }

      if (this.totalTax2 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[1].accountID,
          accountHead: this.taxNames[1].accountHead,
          amount: this.totalTax2,
          type: "Debit",
        });
      }

      if (this.totalTax3 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[2].accountID,
          accountHead: this.taxNames[2].accountHead,
          amount: this.totalTax3,
          type: "Debit",
        });
      }

      if (this.totalBalance == 0) {

        if (this.totalPaidCash > 0) {
          this.counterEntry.push({
            accountID: 2,
            accountHead: 'Cash in hand',
            amount: this.totalPaidCash,
            type: "Credit",
          });
        }
        
        if (this.totalPaidBank > 0) {
          this.counterEntry.push({
            accountID: 8,
            accountHead: 'Cash at bank',
            amount: this.totalPaidBank,
            type: "Credit",
          });
        }

      } else if (this.totalBalance == this.netTotal) {
        this.counterEntry.push({
          accountID: 5,
          accountHead: "Accounts payable",
          amount: this.netTotal,
          type: "Credit",
        });
      } else if(this.totalBalance > 0 && this.item.totalPaid > 0) {
          if (this.totalPaidCash > 0) {
            this.counterEntry.push({
              accountID: 2,
              accountHead: 'Cash in hand',
              amount: this.totalPaidCash,
              type: "Credit",
            });
          }
          
          if (this.totalPaidBank > 0) {
            this.counterEntry.push({
              accountID: 8,
              accountHead: 'Cash at bank',
              amount: this.totalPaidBank,
              type: "Credit",
            });
          }

          this.counterEntry.push({
            accountID: 5,
            accountHead: "Accounts payable",
            amount: this.totalBalance,
            type: "Credit",
          });
      }


    }
    else
    {
      //TRANSFER ENTRY NO NEED
    }

  }

  get currency() {
    return this.store.getters.getCurrency;
  }
}

